import SchoolAvatar from './SchoolAvatar';

export default function SchoolSearchResultRow({
  title,
  subtitle,
  badge,
  seed = 0,
  onClick,
}) {
  return (
    <button type="button" className="sd-search-result-row" onClick={onClick}>
      <SchoolAvatar name={title} seed={seed} className="sd-search-result-avatar" />
      <div className="sd-search-result-copy">
        <div className="sd-search-result-title">{title}</div>
        {subtitle ? <div className="sd-search-result-subtitle">{subtitle}</div> : null}
        {badge ? <span className={`sd-search-result-pill ${badge.tone}`}>{badge.label}</span> : null}
      </div>
      <span className="sd-search-result-arrow" aria-hidden="true">→</span>
    </button>
  );
}
